import React, { useEffect, useState } from 'react';
import { message, DatePicker } from 'antd';

import LineChart from './components/lineChart';
import { memberTrainingTrendIndicator } from '@/services/chartData';

import moment from 'moment';
const { RangePicker } = DatePicker;
const getLastDays = (lastDay) => {
  const current = Date.now();
  const last = current - 3600 * 24 * 1000 * lastDay;
  return moment(last);
};
const UserOverviewData = () => {
  const [lineData, setLineData] = useState([]);
  const [timeRangeValue, setTimeRangeValue] = useState([
    getLastDays(7),
    getLastDays(0),
  ]);
  const dateFormat = 'YYYY-MM-DD';
  const onChangeTimeRangePicker = (e) => {
    setTimeRangeValue(e);
  };
  const onOpenChange = (open, type) => {};
  const queryMemberOverviewData = () => {
    memberTrainingTrendIndicator({
      requestData: {
        startDate: moment(timeRangeValue[0]).format(dateFormat),
        endDate: moment(timeRangeValue[1]).format(dateFormat),
      },
    }).then(({ code, msg, data }) => {
      if (code === '00000') {
        setDatas(data);
      } else {
        message.error(msg);
      }
    });
  };
  const setDatas = (data) => {
    let arr = [];
    arr = arr
      .concat(
        data.trainingTrends
          ? data.trainingTrends[0].trainingTrend.map((i) => {
              return {
                abscissa: i.abscissa,
                ordinate: Number(i.ordinate),
                category: data.trainingTrends[0].memberLabelValue,
              };
            })
          : [],
      )
      .concat(
        data.trainingTrends
          ? data.trainingTrends[1].trainingTrend.map((i) => {
              return {
                abscissa: i.abscissa,
                ordinate: Number(i.ordinate),
                category: data.trainingTrends[1].memberLabelValue,
              };
            })
          : [],
      );
    setLineData(arr);
  };
  useEffect(() => {
    queryMemberOverviewData();
  }, [timeRangeValue]);
  return (
    <div>
      <RangePicker
        value={timeRangeValue}
        allowClear={false}
        onOpenChange={(open) => {
          onOpenChange(open);
        }}
        onChange={onChangeTimeRangePicker}
        picker="date"
        format={dateFormat}
      />
      <LineChart
        lineData={lineData}
        xField="abscissa"
        yField="ordinate"
        seriesField="category"
      />
    </div>
  );
};

export default UserOverviewData;
